<template>
  <button aria-controls="navbar-default" aria-expanded="false" type="button">
    <span class="sr-only">Open main menu</span>
    <SidebarIconMenu class="w-6 h-6" />
  </button>
</template>

<style scoped>
button {
  @apply inline-flex items-center p-2 text-sm text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none
    focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600;
}
</style>
